import React from "react";
import ui from "../../pages/dashboard/DashboardUI.module.css";

// Pill switch used for page tabs (People / Resources), view modes and Active / Archived.
export default function SegmentedControl({ options, value, onChange, ariaLabel }) {
  return (
    <div className={ui.viewToggleGroup} role="tablist" aria-label={ariaLabel}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="tab"
          aria-selected={value === opt.value}
          className={`${ui.viewToggleButton} ${value === opt.value ? ui.viewToggleButtonActive : ""}`}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
          {opt.count != null && ` (${opt.count})`}
        </button>
      ))}
    </div>
  );
}
